import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import i18n, { initI18n } from 'shared/i18n'
import portalBs from './customer/i18n/locales/bs.json'
import portalEn from './customer/i18n/locales/en.json'
import portalHr from './customer/i18n/locales/hr.json'
import portalSr from './customer/i18n/locales/sr.json'

const queryClient = new QueryClient()
const root = document.getElementById('root')!

const i18nType = i18n as Parameters<typeof I18nextProvider>[0]['i18n']

function renderApp() {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <I18nextProvider i18n={i18nType}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </I18nextProvider>
    </React.StrictMode>,
  )
}

// Customer portal namespace (BS, EN, HR, SR). Default language Bosnian.
// Wait for i18n to be ready so translations load before first paint.
// If i18n fails, still mount the app so the user sees content (translations may be missing).
initI18n({
  bs: { portal: portalBs as Record<string, unknown> },
  en: { portal: portalEn as Record<string, unknown> },
  hr: { portal: portalHr as Record<string, unknown> },
  sr: { portal: portalSr as Record<string, unknown> },
})
  .then(renderApp)
  .catch((err) => {
    console.error('i18n init failed, mounting app anyway:', err)
    renderApp()
  })
